import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { User } from '../../../src/app/_models/user';
import { HttpDataService } from '../../../src/app/_service/http-data.service';
import { LoginModel } from '../../../src/app/_models/login-model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  loginurl: string = "http://localhost:5553/user";

  constructor(private httpDataService: HttpDataService) { 
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser') || '{}'));
    this.currentUser = this.currentUserSubject.asObservable();
  }



  login<T>(user){
    let userObj = { Authorization: 'Basic ' + btoa(user.username + ':' + user.password) }
        return this.httpDataService.getBackendDatausehttpgetparamsWithObj<T>(this.loginurl,{},userObj).pipe(map(obj => {
            return obj;
         }));
  }

  logout() {
    // remove user from local storage to log user out
    sessionStorage.removeItem('currentUser');
    this.currentUserSubject.next(new User());
  }
}
